export default __webpack_public_path__ + "static/media/earth-gc15606814_1280.790dd4f7.jpg";